import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as TableSort } from '@assets/svg/table-sort.svg';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const EmailNotificationsUserSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.settingsBlock}>
      <div className={style.facilityBlock}>
        <div className={cx(style.blockHead, style.facilityBlockHead)}>
          <span className={style.blockTitle}>
            {t('Facility')}
            <TableSort className={style.sortIcon} />
          </span>
        </div>
        <div className={style.facilityBlockBody}>
          {[...Array(5)].map(() => (
            <div key={uuidv4()} className={style.facilityItem}>
              <SkeletonBlock className={style.textSkeleton} />
            </div>
          ))}
        </div>
      </div>
      <div className={style.notificationsBlock}>
        <div className={cx(style.blockHead, style.notificationsBlockHead)}>
          <span className={style.blockTitle}>{t('Actions')}</span>
          <SkeletonBlock className={style.checkboxSkeleton} />
          <SkeletonBlock className={style.checkboxSkeleton} />
          <SkeletonBlock className={style.checkboxSkeleton} />
        </div>
        <div className={style.notificationsBlockBody}>
          {[...Array(7)].map(() => (
            <div key={uuidv4()} className={style.notificationsRow}>
              <SkeletonBlock className={style.textSkeleton} />
              <SkeletonBlock className={style.checkboxSkeleton} />
              <SkeletonBlock className={style.checkboxSkeleton} />
              <SkeletonBlock className={style.checkboxSkeleton} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmailNotificationsUserSkeleton;
